import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import Reveal from "./Reveal";

/**
 * Compact list of internal links to the dedicated SEO landing pages.
 * Dropped into /treatments and /about to strengthen crawl priority
 * for each condition-specific page.
 */
const LINKS = [
  { to: "/gupt-rog-doctor-prayagraj", label: "Gupt Rog Doctor in Prayagraj", sub: "Every men's private concern, one senior physician" },
  { to: "/nightfall-treatment-prayagraj", label: "Nightfall Treatment Prayagraj / Allahabad", sub: "Classical care for swapnadosha" },
  { to: "/dhatu-rog-treatment-prayagraj", label: "Dhatu Rog Nightfall Treatment", sub: "Rebuild shukra dhatu with vajikarana" },
  { to: "/low-libido-treatment-prayagraj", label: "Low Libido Treatment Prayagraj", sub: "Restore natural desire without hormones" },
  { to: "/low-sperm-count-treatment-prayagraj", label: "Low Sperm Count Treatment", sub: "3-6 month Ayurvedic fertility programme" },
  { to: "/masturbation-treatment-prayagraj", label: "Masturbation Treatment in Prayagraj", sub: "Respectful, judgement-free recovery" },
  { to: "/sex-clinic-allahabad", label: "Sex Clinic in Allahabad", sub: "The same senior sexologist doctor" },
];

export default function ExploreInDepth({ heading = "Explore condition-specific care", subheading }) {
  return (
    <section className="py-20 lg:py-24 bg-ivory border-y border-border/50" data-testid="explore-in-depth">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <Reveal>
          <div className="overline">Deep-dive pages</div>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl mt-3 max-w-2xl">
            {heading}
          </h2>
          {subheading && <p className="mt-4 text-muted-foreground max-w-2xl">{subheading}</p>}
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {LINKS.map((link, i) => (
            <Reveal key={link.to} delay={i * 0.03}>
              <Link
                to={link.to}
                data-testid={`explore-link-${link.to.slice(1)}`}
                className="group block bg-cream border border-border/60 rounded-2xl p-6 hover:border-terracotta/60 hover:-translate-y-0.5 transition-all duration-300"
              >
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="font-serif-display text-lg leading-tight text-forest">{link.label}</h3>
                    <p className="mt-2 text-xs text-muted-foreground leading-relaxed">{link.sub}</p>
                  </div>
                  <ArrowRight size={18} className="text-terracotta shrink-0 mt-1 group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
